module.exports = __webpack_public_path__ + "img/user-circle-likely-owner.svg";